import { useState, useEffect } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_FAQ } from '../../../../Constants';

export const useFetchCourseFaq = (refresh) => {
  const [faqResponse, setFaqResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaAccess = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await axiosService.get(
          `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_FAQ}?limit=100&page=1`
        );
        setFaqResponse(response?.data);
      } catch (err) {
        console.error(err);
        setError(err.message || 'An error occurred while fetching media access');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMediaAccess();

  }, [refresh]);

  return [ faqResponse, isLoading, error ];
};